import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BrightnessHighIcon(props: IconProps) {
    return <Icon {...props} iconKey={"brightness_high"}/>
}
